import { notFound, redirect } from "@tanstack/react-router";

import { BlogListing, buildListingHead, isThinCategory, pageCount, pageSlice, postsForCategory } from "./BlogListing";
import { BLOG_CATEGORIES, type BlogCategoryKey } from "../../content/blog/categories";

export function categoryConfig(key: BlogCategoryKey) {
  return BLOG_CATEGORIES[key];
}

/** Проверка номера страницы: /page/1 → редирект на базовый URL, вне диапазона → 404. */
export function guardPage(basePath: string, raw: string, totalPages: number): number {
  if (!/^[1-9][0-9]*$/.test(raw)) throw notFound();
  const page = Number(raw);
  if (page === 1) throw redirect({ href: basePath, statusCode: 301 });
  if (page > totalPages) throw notFound();
  return page;
}

export function categoryHead(key: BlogCategoryKey, page: number) {
  const c = BLOG_CATEGORIES[key];
  const list = postsForCategory(c.slug);
  const totalPages = pageCount(list.length);
  const basePath = `/blog/${c.slug}`;
  const path = page > 1 ? `${basePath}/page/${page}` : basePath;

  return buildListingHead({
    title: page > 1 ? `${c.seoTitle.split(" | ")[0]} — страница ${page} | HAY.agency` : c.seoTitle,
    description: page > 1 ? `${c.seoDescription} Страница ${page} из ${totalPages}.` : c.seoDescription,
    path,
    basePath,
    page,
    totalPages,
    items: pageSlice(list, page),
    breadcrumbs: [
      ["Главная", "/"],
      ["Блог", "/blog"],
      [c.name, basePath],
    ],
    noindex: isThinCategory(c.slug),
  });
}

export function BlogCategoryPage({ categoryKey, page }: { categoryKey: BlogCategoryKey; page: number }) {
  const c = BLOG_CATEGORIES[categoryKey];
  const list = postsForCategory(c.slug);
  const totalPages = pageCount(list.length);

  return (
    <BlogListing
      h1={page > 1 ? `${c.h1} — страница ${page}` : c.h1}
      intro={
        <div className="space-y-3">
          {c.intro.map((paragraph) => (
            <p key={paragraph.slice(0, 24)}>{paragraph}</p>
          ))}
        </div>
      }
      items={pageSlice(list, page)}
      page={page}
      totalPages={totalPages}
      basePath={`/blog/${c.slug}`}
      activeCategory={c}
      breadcrumbCurrent={c.name}
      featureFirst={false}
    />
  );
}
